import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const ContactGeniousChangeProfileImage = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const location = useLocation();
  
  const [userId, setUserId] = useState(authState.user._id);
  const [userName, setUserName] = useState(authState.user.name);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [selectedFile, setSelectedFile] = useState(null);
  const [profileImage, setProfileImage] = useState(''); // Holds the path to the profile image
  const [errorMessage, setErrorMessage] = useState('');

  const onFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const validFileTypes = ['image/png'];

      if (!validFileTypes.includes(file.type)) {
        setErrorMessage('File must be in .png format.');

        setSelectedFile(null);
        return;
      }
      if (file.size > 75000) { 
        setErrorMessage('File size must not exceed 75 KB.');
        setSelectedFile(null);
        return;
      }
      setErrorMessage('');
      setSelectedFile(file);
    }
  };


  const onFileUpload = async () => {
    if (!selectedFile) {
      alert('Please select a valid image file first.');
      return;
    }

    const ext = selectedFile.name.split('.').pop();
    const renamedFile = new File([selectedFile], `${userCode}.${ext}`, { type: selectedFile.type });
    // console.log("selected file name /  renamedfilename: ",selectedFile," / ",renamedFile);


    const formData = new FormData();
    formData.append('file', renamedFile);
    formData.append('userCode', userCode);
  
    try {
      const response = await axios.post('/api/uploads/upload-userprofilepic', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      alert('File uploaded successfully!');
      setProfileImage(`/uploads/users/profilepic/${userCode}.${ext}?${new Date().getTime()}`); // Cache-busting query param
    } catch (error) {
      console.error('Error uploading file:', error);
      alert('Failed to upload file');
    }
  };

  
  const navigateBack = () => {
  navigate(-1)
 }

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-800">
      <div className="border-2 flex flex-col items-center p-6 bg-gray-700 rounded-lg w-full max-w-sm">
        <h2 className="text-lg font-bold text-white">Profile Image</h2>
        <img 
          src={`/api/downloads/users/profilepic/${userCode}.png`}
          alt="Profile Pic" 
          style={{ maxWidth: '100%', height: 'auto' }} 
        />
        <h2 className="text-lg font-bold text-white mt-4">Upload New Image</h2>
        <input 
          type="file" 
          accept=".png" 
          onChange={onFileChange} 
          className="mt-2"
        />
        {errorMessage && <p className="text-red-500 text-sm mt-2">{errorMessage}</p>}
        <button 
          onClick={onFileUpload} 
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4"
        >
          Upload
        </button>
        <button 
          onClick={navigateBack} 
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4"
        >
          Back
        </button>
      </div>
    </div>

  );
};

export default ContactGeniousChangeProfileImage;
